import Layout from "../../../../src/components/layout.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop, faUserEdit, faGamepad, faTree } from '@fortawesome/free-solid-svg-icons';
import Image from "../../../../src/components/image.js";
import WilliamAge from "../../../../src/adhoc/william-age.js";
import AlexAge from "../../../../src/adhoc/alex-age.js";
import * as React from 'react';
export default {
  Layout,
  FontAwesomeIcon,
  faLaptop,
  faUserEdit,
  faGamepad,
  faTree,
  Image,
  WilliamAge,
  AlexAge,
  React
};